export default "__VITE_ASSET__By5liPEM__"